import { VueRenderer } from '@tiptap/vue-2'
import tippy from 'tippy.js'
import List from './index.vue'
import DBUtil from '@/utils/DBUtil'
import { unxss } from '@/utils/utils'

export default {
  items: async ({ query }) => {
    // 如果query 是空格开头的，那么就不显示
    if (query.startsWith(' ')) {
      return []
    }
    if (!query) {
      let { memos } = await DBUtil.getNewMemoList()
      return memos.filter((memo) => memo.content)
    }

    let { memos } = await DBUtil.queryMemosWithString(query)
    return memos.map((memo) => {
      return {
        ...memo,
        content: unxss(memo.content),
      }
    })
  },
  render() {
    let component
    let popup
    return {
      onStart: (props) => {
        component = new VueRenderer(List, {
          parent: this,
          propsData: props,
        })

        popup = tippy('body', {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'focusin',
          placement: 'bottom-start',
          inertia: true,
          duration: [0, 0],
          zIndex: 3000,
        })
      },
      onUpdate(props) {
        if (component) {
          component.updateProps(props)
        }
        if (!props.clientRect) {
          return
        }
        if (popup) {
          popup.map((p) => {
            p.setProps({
              getReferenceClientRect: props.clientRect,
            })
          })
        }
      },
      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          popup.map((p) => p.hide())
          return true
        }

        return component && component.ref && component.ref.onKeyDown(props)
      },
      onExit() {
        if (popup) {
          popup.map((p) => p.destroy())
        }

        if (component) {
          component.destroy()
        }
      },
    }
  },
}
